import React, { Fragment } from 'react';
import QuickSearch from '../QuickSearch';
import MiniCart from '../MiniCart';
import LanguageSelector from '../LanguageSelector';
import { useSelector } from 'react-redux';

const MobileTopMenu = ({ toggleMenu }) => {
    const logo = useSelector((state) => state.navigation.logo);
    const hideEcommerceElements = useSelector(
        (state) => state.navigation.hideEcommerceElements
    );

    return (
        <div className="header__row compact-header header__row--one-row hide-desktop">
            <a className="header__logo" href="/">
                <img src={logo.url} alt={logo.text} />
            </a>
            <div className="header__components">
                <LanguageSelector mobile={true} />
							
                <button
                    className="header__mobile-close-button"
                    onClick={(e) => toggleMenu(e)}
                >
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="29"
                        height="30"
                        viewBox="0 0 29 30"
                        fill="none"
                    >
                        <path
                            d="M7.15698 7.84277L21.4709 22.1567"
                            stroke="var(--navigation-icon-color, #FFFFFF)"
                            strokeWidth="2"
                            strokeLinecap="square"
                        />
                        <path
                            d="M7.15698 22.1562L21.4709 7.84231"
                            stroke="var(--navigation-icon-color, #FFFFFF)"
                            strokeWidth="2"
                            strokeLinecap="square"
                        />
                    </svg>
                </button>
            </div>
        </div>
    );
};

export default MobileTopMenu;
